import { createAsyncThunk } from '@reduxjs/toolkit'
import apiRequest from '../../lib/http'
import { normalizeError } from '../../utils/errorHelpers'

export const fetchContactDeleteImpact = createAsyncThunk('contactDelete/fetchImpact', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.get(`/customUsers/${userId}/delete-impact`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})

export const deleteContact = createAsyncThunk('contactDelete/delete', async (userId, { rejectWithValue }) => {
  try {
    const response = await apiRequest.delete(`/customUsers/${userId}`)
    return response.data.data
  } catch (error) {
    return rejectWithValue(normalizeError(error))
  }
})
